import React from "react";
import { PageLayout, PageContent, PageHeader } from "../../ui";
import { useApiKeys } from "../api-keys/hooks/useApiKeys";
import { ApiKeysView } from "../api-keys/components/ApiKeysView";

/**
 * Workspace Settings (016 §4): API-key management. Account details (email, org,
 * password) live on the personal Profile page (avatar menu → Profile). The former
 * duplicate "Account" tab was removed (review v2 §3) so account data has a single
 * home, and the page width matches Profile for a consistent account/settings feel.
 */
export default function SettingsPage() {
  const { apiKeys, isLoading, isGenerating, generateApiKey, removeApiKey, copyApiKey } =
    useApiKeys();

  return (
    <PageLayout>
      <PageContent maxWidth="3xl">
        <PageHeader title="API Keys" description="Manage your workspace API keys." />
        <div className="mt-6">
          <ApiKeysView
            apiKeys={apiKeys}
            isLoading={isLoading}
            isGenerating={isGenerating}
            onGenerate={generateApiKey}
            onCopy={copyApiKey}
            onDelete={removeApiKey}
          />
        </div>
      </PageContent>
    </PageLayout>
  );
}
